var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cookie-bottom-content-settings-btn",on:{"click":function($event){return _vm.$root.$emit('cookies-modal-open')}}},[_vm._v(_vm._s(_vm.t('cookies.settings')))])
}
var staticRenderFns = []

export { render, staticRenderFns }